// !FIXME - Easy - Flow type this file
import React from 'react'

import { white } from 'constants/inlineStyles'
import FlyerGridMenuDropdown from './components/FlyerGridMenuDropdown'
import FlyerSortDropdown from './components/FlyerSortDropdown'
import FlyerDropdownTrigger from './components/DropdownTrigger'
import { css } from 'emotion'

let styles = {}

const FlyerGridMenu = ({
  categoryOptions,
  sortOptions,
  currentCategory,
  currentSortOption,
  handleCategoryChange,
  handleFlyerSortChange
}) => {

  return (
    <div className={cn.root} style={styles.menuWrapper}>
      <div style={styles.whiteText}>
        <FlyerSortDropdown
          className="flyer-dropdown--mid"
          handleChange={handleFlyerSortChange}
          defaultValue={currentSortOption.value}
          options={sortOptions}
          currentOption={currentSortOption}
        />
      </div>
      <div style={styles.whiteText}>
        <FlyerGridMenuDropdown
          trigger={
            <FlyerDropdownTrigger
              value={
                currentCategory === 'all' ? 'All Categories' : currentCategory
              }
              label="Filter"
            />
          }
          className="flyer-dropdown--right"
          options={categoryOptions}
          handleChange={handleCategoryChange}
          defaultValue={currentCategory}
        />
      </div>
    </div>
  )
  
}

styles = {
  menuWrapper: {
    paddingLeft: '1.066667rem',
    paddingRight: '1.066667rem',
    lineHeight: '1.25rem'
  },
  mediumOpacity: { opacity: '.6' },
  whiteText: { color: white }
}
const cn = {
  root: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-family: 'Proxima Nova';
    height: 56px;
    background-color: #45506A;
    @media (max-width: 480px) {
      height: 51px;
    }
  `
}

export default FlyerGridMenu



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridMenu/index.js